import React from 'react';
import FlexView from 'react-flexview/lib';
import { PolicyActivityHistory } from './PolicyView/PolicyUpdates/PolicyActivityHistory';
import { InsuranceStatus } from '../../models/insurance-models/InsuranceStatus';
import dayjs from 'dayjs';
import classNames from 'classnames';

const PolicyHeader = ({ 
    isRenewal, 
    isActiveInsurance,
    setIsRenewal, 
    setIsCoverageDetailsExpanded, 
    insurance, 
    small,
    isAdmin
}) => {
    const getStatus = () => {
        if(!small && insurance.getStatus() == InsuranceStatus.SCHEDULED) {
            let daysLeft = dayjs(insurance.insuranceStart).diff(new Date(), 'day')
            if(daysLeft < 1) return 'Will be active Tomorrow'
            return `Will be active in ${daysLeft} day${daysLeft > 1 ? 's' : ''}`
        }
        else 
            return <span className={classNames('bold',
                    {'green': insurance.getStatus() == InsuranceStatus.ACTIVE},
                    {'blue': insurance.getStatus() == InsuranceStatus.SCHEDULED},
                    {'yellow': insurance.getStatus() == InsuranceStatus.SUSPENDED},
                    {'red': insurance.getStatus() == InsuranceStatus.CANCELED},
                    {'grey': insurance.getStatus() == InsuranceStatus.EXPIRED},
                )}>{insurance.getStatus()}</span>
    }

    return (
        <>
            {/* Header */}
            <FlexView className="policy-header space-between margin-bottom-large">
                <FlexView vAlignContent="center" className="clickable">
                    {!isRenewal && <PolicyActivityHistory insurance={insurance} />}
                </FlexView>
                {isActiveInsurance && <FlexView 
                vAlignContent="center"
                    onClick={() => {
                        setIsRenewal(prev => !prev)
                        setIsCoverageDetailsExpanded(true)
                    }} 
                    className="underline clickable text-small bold"
                >
                    {isRenewal ? 'Policy Details' : 'Renewal Details'}
                </FlexView>}
            </FlexView>

            {/* Policy Title Section */}
            <FlexView column hAlignContent="center" className="margin-bottom-large">
                {!isRenewal?
                    <h1 className="text-title bold">Your {insurance.insurancePeriodDescription} Policy</h1>
                :
                    <h1 className="text-title bold">Renewal Details</h1>
                }
                <FlexView vAlignContent="center" className="margin-top-small">
                    <FlexView marginRight={5} className="text-body">{insurance.policyNumber} | </FlexView>
                    {getStatus()}
                </FlexView>
                <FlexView vAlignContent="center" className="margin-top-small">
                    {isAdmin && insurance.namedInsured.broker_agency !=="" && <FlexView marginLeft={5} className="text-body bold">Broker Agency: {insurance.namedInsured.broker_agency} </FlexView>}
                </FlexView>
            </FlexView>
        </>
    );
};

export default PolicyHeader; 